import { NetlogHttpClient } from 'lib/http';
import { AttachmentHandler, FileId } from './attachment-handler';
import { FileAttachment } from 'models';

export type PenDimensionPipeSegmentDocuemntsHandlerArgs = {
  penDimensionPipeSegmentId: number;
  penDimensionPipeSegmentAttachmentTypeEnum: PenDimensionPipeSegmentAttachmentTypeEnum;
};

export enum PenDimensionPipeSegmentAttachmentTypeEnum {
  BulkHead = 0,
  Weld = 1,
}

export class PenDimensionPipeSegmentDocuemntsHandler implements AttachmentHandler {
  private _penDimensionPipeSegmentId;
  private _penDimensionPipeSegmentAttachmentTypeEnum;
  private hasAttachments;

  constructor(private client: NetlogHttpClient, args: PenDimensionPipeSegmentDocuemntsHandlerArgs) {
    this._penDimensionPipeSegmentId = args.penDimensionPipeSegmentId;
    this._penDimensionPipeSegmentAttachmentTypeEnum = args.penDimensionPipeSegmentAttachmentTypeEnum;
  }

  set setPenDimensionPipeSegmentId(id: number) {
    this.setPenDimensionPipeSegmentId = id;
  }

  get baseUrl() {
    return `api/pen-dimension-pipe-segment/${this._penDimensionPipeSegmentId}/attachments`;
  }

  get hasAttachment() {
    return this.hasAttachments;
  }

  upload(file: File) {
    const form = this.client.fileFormdata(file);
    return this.client.uploadFile(form, this.baseUrl + `/${this._penDimensionPipeSegmentAttachmentTypeEnum}`);
  }

  delete(storageFileId: FileId) {
    return this.client.delete({
      url: `${this.baseUrl}/${storageFileId}`,
    });
  }

  download(storageFileId: FileId) {
    return this.client.downloadBlob(`api/system-storage/${storageFileId}`);
  }

  async metadata() {
    const response = await this.client.get<FileAttachment[]>(
      {
        url: `api/pen-dimension-pipe-segment/${this._penDimensionPipeSegmentId}/attachments/${this._penDimensionPipeSegmentAttachmentTypeEnum}`,
        model: FileAttachment,
      },
      { cache: false }
    );
    this.hasAttachments = response.data.length > 0 ? true : false;
    return response.data;
  }
}
